// Translation for en
export const or = {
        common: {
            save: 'Save',
            cancel: 'Cancel',
            close: 'Close',
            delete: 'Delete',
            edit: 'Edit',
            activate: 'Activate',
            add: 'Add',
            saving: 'Saving...',
            loading: 'Loading...',
            active: 'ACTIVE',
            inUse: 'In Use',
            test: 'Test',
            searchApps: 'Search apps...',
            betaBanner: 'BETA - Service not available yet!'
        },
        header: {
            creditBalance: 'Balance',
            minutes: 'MIN'
        },
        auth: {
            signIn: 'Sign In',
            signUp: 'Sign Up',
            username: 'Username',
            password: 'Password',
            continue: 'Continue',
            noAccount: 'Don\'t have an account?',
            hasAccount: 'Already have an account?',
            loginError: 'Login failed',
            invalidCredentials: 'Invalid username or password',
            rateLimited: 'Too many login attempts. Please wait a moment.',
            sessionExpired: 'Your session has expired. Please use a new magic link.',
            magicLinkInvalid: 'The login link is invalid or has expired.',
            magicLinkSuccess: 'Welcome! You have been successfully logged in.',
            magicLinkProcessing: 'Processing login...',
            connectionError: 'Connection error. Please try again.'
        },
        profile: {
            myProgress: 'My Learning Progress',
            signOut: 'Sign Out',
            plan: 'Plan: '
        },
        settings: {
            title: 'Settings',
            tabs: {
                uiSettings: 'UI Settings',
                systemPrompt: 'System Prompt',
                llmProfiles: 'LLM Profiles',
                ttsProfiles: 'TTS Profiles',
                language: 'Language',
            },
            uiSettings: {
                title: 'User Interface',
                themeMode: 'Theme Mode',
                darkMode: 'Dark Mode',
                lightMode: 'Light Mode',
                themeColor: 'Theme Color',
                themeColorDesc: 'Choose the accent color for buttons, icons and highlights',
                background: 'Background',
                backgroundDesc: 'Choose a background for your workspace',
                selectBackgroundColor: 'Select Background Color',
                backgrounds: {
                    cyberSchooling: 'Cyber Schooling',
                    focus: 'Focus',
                    concentration: 'Concentration',
                    relaxation: 'Relaxation',
                    lianas: 'Lianas',
                    color: 'Color'
                },
                backgroundColors: {
                    deepDark: 'Deep Dark',
                    darkGrey: 'Dark Grey',
                    midnightBlue: 'Midnight Blue',
                    indigo: 'Indigo',
                    darkTeal: 'Dark Teal',
                    brown: 'Brown',
                    darkRed: 'Dark Red',
                    deepPurple: 'Deep Purple',
                    pureWhite: 'Pure White',
                    softWhite: 'Soft White',
                    lightGrey: 'Light Grey',
                    paleBlue: 'Pale Blue',
                    paleGreen: 'Pale Green',
                    paleOrange: 'Pale Orange',
                    lavender: 'Lavender',
                    blueGrey: 'Blue Grey'
                }
            },
            systemPrompt: {
                label: 'System Prompt:',
                placeholder: 'Loading system prompt...',
                emptyError: 'System prompt cannot be empty!',
                saveSuccess: '✓ System prompt saved successfully!',
                loadError: 'Error loading system prompt',
                saveError: 'Error saving'
            },
            llmProfiles: {
                addButton: '+ Add New Connection',
                newConnection: 'New Connection',
                editConnection: 'Edit Connection',
                emptyState: 'No LLM connections available. Click below to add one.',
                loadingProfiles: 'Loading profiles...',
                nameLabel: 'Name *',
                namePlaceholder: 'e.g. OpenAI GPT-4',
                apiUrlLabel: 'API URL *',
                apiUrlPlaceholder: 'https://api.openai.com/v1/chat/completions',
                apiKeyLabel: 'API Key *',
                apiKeyPlaceholder: 'sk-...',
                modelLabel: 'Model *',
                modelPlaceholder: 'gpt-4, mistral-tiny, etc.',
                allFieldsRequired: 'All fields must be filled!',
                saveSuccess: '✓ Profile saved successfully!',
                deleteConfirm: 'Do you really want to delete "{name}"?',
                profileNotFound: 'Profile not found!',
                loadError: 'Error loading profiles',
                saveError: 'Error saving',
                activateError: 'Error activating',
                deleteError: 'Error deleting',
                modelInfo: 'Model: {model} | API: {api}'
            },
            ttsProfiles: {
                addButton: '+ Add New Voice',
                newVoice: 'New Voice',
                editVoice: 'Edit Voice',
                emptyState: 'No TTS profiles available. Click below to add one.',
                loadingProfiles: 'Loading TTS profiles...',
                nameLabel: 'Name',
                namePlaceholder: 'e.g. My ElevenLabs Adam',
                providerLabel: 'Provider',
                providerPlaceholder: 'e.g. ElevenLabs, OpenAI, Piper',
                providerPiper: 'Piper (Local)',
                providerOpenAI: 'OpenAI',
                providerElevenLabs: 'ElevenLabs',
                providerAzure: 'Azure',
                apiUrlLabel: 'API URL *',
                apiUrlPlaceholder: 'https://api.example.com/tts',
                apiKeyLabel: 'API Key *',
                apiKeyPlaceholder: 'sk-...',
                modelIdLabel: 'Model ID *',
                modelIdPlaceholder: 'e.g. eleven_monolingual_v1',
                voiceIdLabel: 'Voice ID',
                voiceIdPlaceholder: 'e.g. pNInz6obpgDQGcFmaJgB',
                allFieldsRequired: 'All fields must be filled!',
                saveSuccess: '✓ TTS profile saved successfully!',
                deleteConfirm: 'Do you really want to delete "{name}"?',
                loadError: 'Error loading TTS profiles',
                saveError: 'Error saving',
                activateError: 'Error activating',
                deleteError: 'Error deleting'
            },
            language: {
                title: 'Choose Language',
                description: 'Select your preferred language for the user interface'
            },
        },
        chat: {
            ready: 'Ready',
            start: 'START',
            stop: 'STOP',
            initialMessage: 'Click START for real-time conversation.',
            listening: 'Listening...',
            speaking: 'Thorsten is speaking...',
            userLabel: 'You',
            aiLabel: 'AI',
            modalTitle: 'Thorsten AI Chat',
            inputPlaceholder: 'Type a message...',
            send: 'Send',
            loginRequired: 'Please sign in to use this service.',
            loginButton: 'Sign In Now',
            magicLinkRequired: 'Please use a magic link to sign in.',
            creditLimitError: 'Your hourly quota has been exhausted. Please upgrade your plan (Medium/Premium) to continue.',
            serviceDisabled: 'ଚାଟ୍ ସେବା ବର୍ତ୍ତମାନ ଉପಲବ୍ଧ ନାହିଁ। ଦୟାକରି ପରେ ପୁନଃ ଚେଷ୍ଟା କରନ୍ତୁ।'
        },
        notifications: {
            error: 'Error',
            success: 'Success',
            info: 'Information',
            unknownError: 'An unknown error occurred'
        },
        cookie: {
            message: 'This website uses cookies to provide you with the best possible user experience.',
            accept: 'Accept'
        },
        curriculum: {
                buttonLabel: 'ପାଠ୍ୟକ୍ରମ',
                buttonTitle: 'ପାଠ୍ୟକ୍ରମ ବିଷୟବସ୍ତୁ ଦେଖାନ୍ତୁ',
                modalTitle: '{app} ପାଠ୍ୟକ୍ରମ',
                sections: {
                    topic: 'ପାଠ୍ୟକ୍ରମ ବିଷୟ',
                    explanation: 'ଶିଶୁ-ଅନୁକୂଳ ବ୍ୟାଖ୍ୟା',
                    studentProfile: 'ଛାତ୍ର ପ୍ରୋଫାଇଲ୍'
                },
                topic: {
                    empty: 'ଏହି ମାଇକ୍ରୋ-ଆପ୍ ସହିତ ବ୍ୟାକଏଣ୍ଡରେ କୌଣସି ପାଠ୍ୟକ୍ରମ ବିଷୟ ଲିଙ୍କ୍ ହୋଇନାହିଁ।',
                    missingDetail: 'ଏହି ମାଇକ୍ରୋ-ଆପ୍ ପାଇଁ ବିସ୍ତୃତ ପାଠ୍ୟକ୍ରମ ତଥ୍ୟ ବ୍ୟାକଏଣ୍ଡରେ ଏପର୍ଯ୍ୟନ୍ତ ଉପଲବ୍ଧ ନାହିଁ।',
                    learningGoals: 'ଶିକ୍ଷଣ ଲକ୍ଷ୍ୟ',
                    prerequisites: 'ପୂର୍ବାବଶ୍ୟକତା',
                    unitLabel: 'ୟୁନିଟ୍',
                    durationLabel: 'ଅବଧି',
                    difficultyLabel: 'କଠିନତା',
                    hours: 'ଘଣ୍ଟା',
                    minutes: 'ମିନିଟ୍'
                },
                explanation: {
                    empty: 'କୌଣସି ଶିଶୁ-ଅନୁକୂଳ ବ୍ୟାଖ୍ୟା ଉପଲବ୍ଧ ନାହିଁ।',
                    loadingPrepare: 'AI ବ୍ୟାଖ୍ୟା ପ୍ରସ୍ତୁତ କରୁଛି',
                    loadingExplain: 'AI ଶିଶୁ-ଅନୁକୂଳ ଭାଷାରେ ବିଷୟ ବୁଝାଉଛି',
                    requestFailed: 'ଶିଶୁ-ଅନୁକୂଳ ବ୍ୟାଖ୍ୟା ଉତ୍ପନ୍ନ କରାଯାଇପାରିଲା ନାହିଁ।'
                },
                studentProfile: {
                    country: 'ଦେଶ',
                    region: 'ରାଜ୍ୟ / ଅଞ୍ଚଳ',
                    schoolType: 'ବିଦ୍ୟାଳୟ ପ୍ରକାର',
                    grade: 'ଶ୍ରେଣୀ',
                    noContext: 'କୌଣସି ଛାତ୍ର ପ୍ରସଙ୍ଗ ଉପଲବ୍ଧ ନାହିଁ।',
                    childProfileNotFound: 'ବର୍ତ୍ତମାନର ଲଗଇନ୍ ପାଇଁ ବ୍ୟାକଏଣ୍ଡରେ କୌଣସି ଛାତ୍ର ପ୍ରୋଫାଇଲ୍ ମିଳିଲା ନାହିଁ।',
                    loginProfileIncomplete: 'ଲଗଇନ୍ ପ୍ରୋଫାଇଲରେ ଏପର୍ଯ୍ୟନ୍ତ ଏକ ସମ୍ପୂର୍ଣ୍ଣ ଛାତ୍ର ପ୍ରସଙ୍ଗ ନାହିଁ।',
                    educationContextNotFound: 'ଏକ ଛାତ୍ର ପ୍ରୋଫାଇଲ୍ ମିଳିଲା, କିନ୍ତୁ କୌଣସି ପାଠ୍ୟକ୍ରମ ନିର୍ଦ୍ଧାରଣ ସେଟ୍ ହୋଇନାହିଁ।',
                    noToken: 'କୌଣସି ସାଇନ୍-ଇନ୍ ଛାତ୍ର ମିଳିଲା ନାହିଁ।'
                },
                errors: {
                    signInRequired: 'ପାଠ୍ୟକ୍ରମ ଦେଖିବା ପାଇଁ ଦୟାକରି ସାଇନ୍ ଇନ୍ କରନ୍ତୁ।',
                    appIdMissing: 'ଆପ୍ ID ନାହିଁ।',
                    loadFailed: 'ପାଠ୍ୟକ୍ରମ ତଥ୍ୟ ଲୋଡ୍ କରାଯାଇପାରିଲା ନାହିଁ।'
                }
            }
    };
